var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "close-svg",
      attrs: {
        "data-testid": _vm.testId,
        width: "32",
        height: "46",
        viewBox: "0 0 32 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.9835 21.5757L10.3104 15.9027L8.89844 17.3147L14.5714 22.9877L8.90234 28.6568L10.3143 30.0688L15.9835 24.3997L21.6397 30.056L23.0517 28.644L17.3955 22.9877L23.061 17.3222L21.649 15.9102L15.9835 21.5757Z",
          fill: "black"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }